import React from "react";
import { Select, MenuItem, Typography, SelectChangeEvent } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
	root: {
		minWidth: "200px",
	},
}));

export interface PrinterSelectProps {
	printers: any[];
	handleChange: (event: SelectChangeEvent<string>) => void;
	selectedPrinterId?: string;
	title?: string;
	outputType?: string;
	disabled?: boolean;
}

export default function PrinterSelect(props: PrinterSelectProps) {
	const classes = useStyles();
	const { printers, handleChange, selectedPrinterId, title, outputType, disabled } = props;

	return (
		<React.Fragment>
			<Typography variant="body1">{title ?? "Default Printer"}</Typography>
			<Select id="printer-select" className={classes.root} onChange={handleChange} value={selectedPrinterId ?? ""} disabled={disabled}>
				{printers
					.filter((p) => !outputType || p.outputType === outputType)
					?.map((printer) => (
						<MenuItem key={printer.id} value={printer.id}>
							{printer.name}
						</MenuItem>
					))}
			</Select>
		</React.Fragment>
	);
}
